import { useEffect } from 'react';

import type { UseAddProductsModalEffectsProps } from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/types';

export const useAddProductsModalEffects = ({
  checkedKeysHandler,
}: UseAddProductsModalEffectsProps) => {
  useEffect(() => {
    checkedKeysHandler();
  }, [checkedKeysHandler]);
};
